/**
 * @format
 */

// Rastgelelik köprüsü HER ŞEYDEN önce (9.34 · D-616): @noble anahtar üretimini
// `crypto.getRandomValues`'a dayandırıyor ve RN bunu sağlamıyor. Kurulmazsa
// şifreleme sessizce düz metne düşer. Import'un kendisi kuruyor — bu satır
// listenin başında kalmalı.
import './src/e2ee/randomSource';

import 'react-native-gesture-handler';
import { registerRootComponent } from 'expo';
import App from './App';

// Expo Go + native — registerRootComponent hem "main" olarak kaydeder
registerRootComponent(App);
